import qs, { ParsedQuery } from 'query-string';

/**
 * 키 값이 빈 문자열 혹은 문자열 배열일 경우를 위한 레코드 타입으로의 헬퍼 함수
 * @param qsObject qs 모듈로 쿼리 스트링을 파싱한 객체
 */
function qsObjectToRecord<T extends string>(qsObject: ParsedQuery) {
  const record = {} as Record<T, string>;

  for (const [key, value] of Object.entries(qsObject)) {
    if (!value) continue;
    if (Array.isArray(value)) {
      record[key] = value.join(',');
    } else {
      record[key] = value;
    }
  }

  return record;
}

/**
 * URL 쿼리 스트링을 파싱해 Record<string, string> 형식 객체로 반환합니다.
 */
export function getAllQueryParams<T extends string>() {
  return qsObjectToRecord<T>(qs.parse(location.search));
}

/**
 * keys 목록에 해당하는 키들을 URL 쿼리 스트링에서 파싱해 Record<string, string> 형식 객체로 반환합니다.
 */
export function pickQueryParams<T extends string>(keys: T[]) {
  return qsObjectToRecord<T>(
    qs.parse(qs.extract(qs.pick(location.href, keys)))
  );
}

/**
 * keys 목록에 해당하는 키들을 제외한 키들을 URL 쿼리 스트링에서 파싱해 Record<string, string> 형식 객체로 반환합니다.
 */
export function excludeQueryParams<T extends string>(keys: T[]) {
  return qsObjectToRecord(
    qs.parse(qs.extract(qs.exclude(location.href, keys)))
  );
}
